'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var PeerId = require('peer-id');

var PeerInfo = require('peer-info');

var multiaddr = require('multiaddr');

var mafmt = require('mafmt');

var EventEmitter = require('events').EventEmitter;

var debug = require('debug');

var nextTick = require('async/nextTick');

var log = debug('libp2p:bootstrap');
log.error = debug('libp2p:bootstrap:error');

function isIPFS(addr) {
  try {
    return mafmt.IPFS.matches(addr);
  } catch (e) {
    return false;
  }
}

var Bootstrap =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(Bootstrap, _EventEmitter);

  function Bootstrap(options) {
    var _this;

    _classCallCheck(this, Bootstrap);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Bootstrap).call(this));
    _this._list = options.list;
    _this._interval = options.interval || 10000;
    _this._timer = null;
    return _this;
  }

  _createClass(Bootstrap, [{
    key: "start",
    value: function start(callback) {
      var _this2 = this;

      if (this._timer) {
        return nextTick(function () {
          return callback();
        });
      }

      this._timer = setInterval(function () {
        return _this2._discoverBootstrapPeers();
      }, this._interval);
      nextTick(function () {
        callback();

        _this2._discoverBootstrapPeers();
      });
    }
  }, {
    key: "_discoverBootstrapPeers",
    value: function _discoverBootstrapPeers() {
      var _this3 = this;

      this._list.forEach(function (candidate) {
        if (!isIPFS(candidate)) {
          return log.error('Invalid multiaddr');
        }

        var ma = multiaddr(candidate);
        var peerId = PeerId.createFromB58String(ma.getPeerId());
        PeerInfo.create(peerId, function (err, peerInfo) {
          if (err) {
            return log.error('Invalid bootstrap peer id', err);
          }

          peerInfo.multiaddrs.add(ma);

          _this3.emit('peer', peerInfo);
        });
      });
    }
  }, {
    key: "stop",
    value: function stop(callback) {
      nextTick(callback);

      if (this._timer) {
        clearInterval(this._timer);
        this._timer = null;
      }
    }
  }]);

  return Bootstrap;
}(EventEmitter);

exports = module.exports = Bootstrap;
exports.tag = 'bootstrap';